import { Sling as Hamburger } from 'hamburger-react'
import React, { useState } from 'react'

const Burger = (props) => {

    const [isOpen, setOpen] = useState(false)



  return (
    <>
     <Hamburger color='white' rounded toggled={isOpen} toggle={setOpen} onToggle={props.onVisibility}/>
    </>
  )
}

export default Burger